import { EActionState, IProxyPhoneDto } from '@/models';

export interface IProxyPhoneState {
	companyFilter: string;
	data: IProxyPhoneDto[];
	loaded: EActionState;
	ownerFilter: string;
	unlocking: EActionState;
	syncing: EActionState;
}

export const initialState: IProxyPhoneState = {
	companyFilter: '',
	data: [],
	loaded: EActionState.PENDING,
	ownerFilter: '',
	unlocking: EActionState.PENDING,
	syncing: EActionState.PENDING
};
